import { useEffect } from 'react'
import { getCurrentScope } from '@sentry/react'
import type { WithRequired } from '../types/utils'

type AreaTag = 'quickbet-deposit' | 'account-deposit' | 'self-verification'

type UseSentryScopeParams = {
  areaTag: AreaTag
  userId: number | null
  useUserIdAsFingerprint?: boolean
}

export const useSentryScope = ({
  areaTag,
  userId,
  useUserIdAsFingerprint = false,
}: UseSentryScopeParams) => {
  useEffect(() => {
    configureSentryScope({ areaTag, userId, useUserIdAsFingerprint })
    return () => {
      resetSentryScope(!!userId)
    }
  }, [areaTag, useUserIdAsFingerprint, userId])
}

const configureSentryScope = ({
  areaTag,
  userId,
  useUserIdAsFingerprint,
}: WithRequired<UseSentryScopeParams, 'useUserIdAsFingerprint'>) => {
  getCurrentScope().setTag('area', areaTag)

  if (userId) {
    getCurrentScope().setUser({ id: userId })
  }

  if (userId && useUserIdAsFingerprint) {
    getCurrentScope().setFingerprint([userId.toString()])
  }
}

const resetSentryScope = (clearUser: boolean) => {
  getCurrentScope().setTag('area', undefined)
  clearUser && getCurrentScope().setUser(null)
  getCurrentScope().setFingerprint(['{{ default }}'])
}
